import { Link } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import MuiLink from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import UserAvatar from "./components/UserAvatar";
import OrgaoSelector from "./components/OrgaoSelector";
import Box from "@material-ui/core/Box";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Grid from "@material-ui/core/Grid";
import { useHeaderStyles } from "./styles";
import { useBreadcrumbs } from "../../../../contexts/breadcrumb";

export default function Header() {
  const { classes } = useHeaderStyles();
  const { breadcrumbs } = useBreadcrumbs();

  function handleClick() {
    // Handle the click event
    console.log("Breadcrumb clicked");
  }

  return (
    <Grid item className={classes.root}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {breadcrumbs.map((breadcrumb, index) =>
          index < breadcrumbs.length - 1 ? (
            <MuiLink
              key={index}
              color="inherit"
              className={classes.link}
              to={breadcrumb.path}
              component={Link}
            >
              <Box className={classes.breadcrumb}>
                {breadcrumb.icon && (
                  <breadcrumb.icon style={{ fontSize: 16 }} />
                )}
                {breadcrumb.label}
              </Box>
            </MuiLink>
          ) : (
            <Typography
              key={index}
              color="textPrimary"
              className={classes.breadcrumb}
            >
              <Box className={classes.breadcrumb}>
                {breadcrumb.icon && (
                  <breadcrumb.icon style={{ fontSize: 16 }} />
                )}
                {breadcrumb.label}
              </Box>
            </Typography>
          )
        )}
      </Breadcrumbs>
      <Box display="flex" alignItems="center" style={{ gap: 16 }}>
        <OrgaoSelector />
        <UserAvatar />
      </Box>
    </Grid>
  );
}
